import { t } from 'i18next';

export function formatRelativeDate(startedAt: string): string {
  // Добавляем 'Z', чтобы JS трактовал входящую строку строго как UTC+0
  // Заменяем пробел на 'T' для соответствия стандарту ISO 8601
  const formattedIso = startedAt.replace(' ', 'T').endsWith('Z')
    ? startedAt.replace(' ', 'T')
    : `${startedAt.replace(' ', 'T')}Z`;

  const start = new Date(formattedIso);
  const now = new Date();

  // Методы getFullYear(), getMonth() и getDate() вернут данные уже в часовом поясе клиента
  const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Считаем разницу в днях между текущим днем клиента и датой старта
  const diffTime = nowDateOnly.getTime() - startDateOnly.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  // Форматируем время в локальном виде ЧЧ:ММ для зоны клиента
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  const timeStr = start.toLocaleTimeString('ru-RU', timeOptions);

  // Сценарий 1: Сегодня
  if (diffDays === 0) {
    return `${t('Today')} ${timeStr}`;
  }

  // Сценарий 2: Вчера
  if (diffDays === 1) {
    return `${t('Yesterday')} ${timeStr}`;
  }

  // Сценарий 3: Более ранняя или будущая дата
  const dateOptions: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };
  const dateStr = start.toLocaleDateString('ru-RU', dateOptions);

  // Если год не совпадает с текущим, добавляем его к выводу
  if (start.getFullYear() !== now.getFullYear()) {
    return `${dateStr} ${start.getFullYear()} г. ${timeStr}`;
  }

  return `${dateStr} ${timeStr}`;
}

export function getSecondsBehind(startedAtStr: string): number {
  // Добавляем 'Z', чтобы JS трактовал входящую строку строго как UTC+0
  // Заменяем пробел на 'T' для соответствия стандарту ISO 8601
  const formattedIso = startedAtStr.replace(' ', 'T').endsWith('Z')
    ? startedAtStr.replace(' ', 'T')
    : `${startedAtStr.replace(' ', 'T')}Z`;

  const startedAt = new Date(formattedIso);
  const now = new Date();

  // Разница в миллисекундах делится на 1000
  // getTime() всегда возвращает UTC-таймстамп, поэтому смещение часовых поясов учтется автоматически
  const diffInSeconds = Math.floor((now.getTime() - startedAt.getTime()) / 1000);

  // Возвращаем 0, если время started_at вдруг оказалось в будущем
  return Math.max(0, diffInSeconds);
}

export function formatSecondsToMMSS(totalSeconds: number): string {
  // Защита от отрицательных значений
  const secondsInput = Math.max(0, totalSeconds);

  const minutes = Math.floor(secondsInput / 60);
  const seconds = secondsInput % 60;

  // Добавляем ведущие нули, если число меньше 10
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${paddedMinutes}:${paddedSeconds}`;
}
